/********************************************************************
 * Project: WDCK（2021）
 * Class: InputTimeDirective
 * ----------------------------------------
 * <summary>
 * Input Postal code Directive
 * </summary>
 * <history>
 *      ThaiTV     2021/07/19      Create
 * </history>
 ********************************************************************/
import { Utility } from '../utility/utility';
import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: 'input[postalForm]',
})
export class PostalFormDirective {
    @Output() ngModelChange = new EventEmitter();
    postalRegex = /[^0-9\s]/g;
    constructor(private el: ElementRef, private util: Utility) {
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.el.nativeElement.value;
        // this.el.nativeElement.value = initalValue.replace(this.postalRegex, '');
        if (initalValue !== this.el.nativeElement.value && event.inputType !== 'deleteContentBackward') {
            if (this.el.nativeElement.value === '') {
                this.ngModelChange.emit(this.el.nativeElement.value);
            }
            event.preventDefault();
            event.stopPropagation();
        }
        else{
            this.ngModelChange.emit(this.el.nativeElement.value);
            event.preventDefault();
            event.stopPropagation();
        }
        // 20250120 #18640 modify strat
        // if (this.el.nativeElement.value.length > 10) {
        /* 20250208 #18640 modify start */
        // if (this.el.nativeElement.value.length > 7) {    
        if (this.el.nativeElement.value.length > 10) {
        /* 20250208 #18640 modify end */
        // 20250120 #18640 modify end    
            const postVal = this.el.nativeElement.value.replace(/\s/g, '');
            this.el.nativeElement.value = this.util.ReplaceAll(postVal, ' ', '').substring(0, 10);
        }
    }
    @HostListener('keydown', ['$event']) onKeyDownEvent(e){
        const curText =  $(e.target).val();
        // 20250120 #18640 modify strat
        // if (curText != null && curText.toString().replace(/\s/g, '').length >= 10
        /* 20250208 #18640 modify start */
        // if (curText != null && curText.toString().replace(/\s/g, '').length >= 7
        if (curText != null && curText.toString().replace(/\s/g, '').length >= 10
        /* 20250208 #18640 modify end */
        // 20250120 #18640 modify end
        && !( e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 46 )){
          e.preventDefault();
        }
        if (e.keyCode === 32 && (curText == null || curText.toString().length !== 3)){
          e.preventDefault();
        }
        if (!((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)
          || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 46 || e.keyCode === 32)) {
          e.preventDefault();
        }
    }
    @HostListener('focus', ['$event']) onFocus(event) {
        const initalValue = this.el.nativeElement.value;
        this.el.nativeElement.value = initalValue.replace(this.postalRegex, '');
        if (initalValue !== this.el.nativeElement.value && event.inputType !== 'deleteContentBackward') {
            event.stopPropagation();
        }
        if (this.el.nativeElement.value.length > 3) {
            const postVal = this.el.nativeElement.value.replace(/\s/g, '');
            this.el.nativeElement.value = this.util.ReplaceAll(postVal, ' ', '');
        }
    }
    @HostListener('focusout', ['$event']) onFocusOut(event) {
        const initalValue = this.el.nativeElement.value;
        this.el.nativeElement.value = initalValue.replace(this.postalRegex, '');
        if (initalValue !== this.el.nativeElement.value && event.inputType !== 'deleteContentBackward') {
            event.stopPropagation();
        }
        /* 20250208 #18640 modify start */
        // if (this.el.nativeElement.value.length > 3) {
        if (this.el.nativeElement.value.length == 7) {
        /* 20250208 #18640 modify end */
            const postVal = this.el.nativeElement.value.replace(/\s/g, '');
            this.el.nativeElement.value = postVal.substring(0, 3) + ' ' + postVal.substring(3);
        }
    }
}
